exports = module.exports = require("../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".time_content{padding:10px}ol li{font-size:14px;line-height:24px}pre{overflow:auto;word-wrap:normal;margin:0;padding:.85em 1em;margin-bottom:1.275em;background:#f0fafa;margin:6px 0}.picture{width:60%;display:block;margin:10px 0}.quick_content{padding:10px;box-sizing:content-box;width:100%;overflow:auto}.quick_content p{font-size:16px;line-height:24px}.quick-title{margin-bottom:6px}pre{font-family:Consolas,Menlo,Courier,monospace}", ""]);

// exports
